export enum VocabularyGenerateTypesEnum {
  list = 0,
  cards = 1
}
